import * as React from 'react';
import { darken, lighten, alpha } from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Bs4Tooltip from '../Bs4Components/Bs4Tooltip';
import Fab from '@mui/material/Fab';
import { v4 as uuidv4 } from 'uuid';

import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4ReportGeneric from './Bs4ReportGeneric';
import { Typography } from '@mui/material';
import { SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';
import Bs4I18N from '../Bs4I18N';
import Bs4ViewAvatar from '../Bs4Components/Bs4ViewAvatar';
import { useScrollTarget } from '../Bs4Components/HideOnScroll';

export default class Bs4ReportTypeInfinity extends Bs4ReportGeneric {  

  currentTitle = document.title;
  startScrollingTitleNew = 0;
  startScrollingTitleIntervalID = null;
  startScrollingTitleNewText = '';

  startScrollingTitle = (data) => {        
    if (Array.isArray(data)) this.startScrollingTitleNew += data.length;    
    if (this.startScrollingTitleIntervalID) return;
    
    let side = false;
    this.startScrollingTitleIntervalID = setInterval(() => {
      if (document.visibilityState === "visible" || this.startScrollingTitleNew === 0) {      
        clearInterval(this.startScrollingTitleIntervalID);
        this.startScrollingTitleIntervalID = null;
        this.startScrollingTitleNew = 0;
        document.title = this.currentTitle;
        // console.log('...???...Infinity Stop!!!', side, document.visibilityState, this.startScrollingTitleNew);
        return;
      }

      if (side) {
        document.title = this.startScrollingTitleNewText+this.startScrollingTitleNew;        
      } else {
        document.title = this.currentTitle;
      }
      // console.log('...???...Infinity Title', side, document.visibilityState, this.startScrollingTitleNew);
      side = !side;      
    }, 2000);
  }

  reload = () => {
    // console.log('....Infinity Reload...')
    this.fetchMore(true)
  }

  lastFetchMoreTime = null;

  fetchMore = (reload) => {
    const report = this;
    const baseValues = this.defaultCriteriaVals();
    baseValues.lastBs4rowId = this?.lastRowData?.id || 0;
    this.lastBs4rowIdfetchMore = baseValues.lastBs4rowId;
    if (reload) baseValues.lastBs4rowId = 0;
    const newBaseValues = Bs4MainDispatch.getParserParams(baseValues, this.bs4KartotekaId);
    const formData = new FormData();
    for (let [key, value] of Object.entries(newBaseValues)) formData.append(key, value);    
    const lastFetchMoreTime = new Date().getTime();
    this.lastFetchMoreTime = lastFetchMoreTime;
    // console.log('.... fetchMore ....', reload, lastFetchMoreTime)
    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4ReportData'), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {
      try {
        const returnedJson = JSON.parse(returnedText);
        Bs4MainDispatch.parsingBs4Response(returnedJson, this.bs4KartotekaId);
        if (!Array.isArray(returnedJson.dane) || returnedJson.dane.length < 1) return;
        // console.log('...Bs4ReportTypeInfinity...fetchMore... ', returnedJson);
        //const dataF = returnedJson.dane.filter((record, index) => index < 5);
        const data = returnedJson.dane.map(record => {
          record.id = record.id || uuidv4();
          this.lastRowData = record;
          return record;
        })        

        if (reload) report.replaceData(data);
        else {
          report.addData(data);
          this.startScrollingTitle(data);
        }

        if (Array.isArray(data) && data.length > 0 && this.lastFetchMoreTime === lastFetchMoreTime) {
          report.fetchMore();
        }

      } catch (error) {
        console.log(returnedText);
        console.log(error);        
      }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  addData = () => {
    console.log('== Error === addData == not implemented')
  }

  replaceData = () => {
    console.log('== Error === replaceData == not implemented')
  }

  convertData = (data, columnToShow) => {
    const convertedData = [];
    (data || []).forEach(row => {
      try {
        const jsonRow = JSON.parse(row[columnToShow]);
        const jsonRow1 = JSON.parse(row[columnToShow]);
        jsonRow.id = row.id;
        if (jsonRow.centertop) convertedData.push({
          align: "center",
          body: jsonRow.centertop,
          id: row.id+'_centertop',
          centertop: true,
        });
        convertedData.push(jsonRow);
        if (jsonRow.centerbottom) convertedData.push({
          align: "center",
          body: jsonRow.centerbottom,
          id: row.id+'_centerbottom',
          centerbottom: true,
        });
        delete jsonRow.centertop
        delete jsonRow.centerbottom
      } catch(error) {
        console.log(error)
        console.log('...convertData... error', row)
      }
    })
    // return data.map(row => {
    //   try {
    //     const jsonRow = JSON.parse(row[columnToShow]);
    //     jsonRow.id = row.id;
    //     return jsonRow;
    //   } catch(error) {
    //     return {
    //       id: row.id,
    //       error: error,
    //       errorRow: row,
    //     };
    //   }
    // })
    return convertedData;
  }  

  getAlingnMsg = (props) => {
    switch (props.row.align) {
      case 'left': return {marginLeft: (this.shiftMessageX + 3)+'px'};
      case 'right': return {marginRight: (this.shiftMessageX + 3)+'px'};
      default: return {};
    }    
  }

  getAlingn = (props) => {
    switch (props.row.align) {
      case 'left': return {direction: 'row', justifyContent: 'flex-start', alignItems: 'flex-start'};
      case 'center': return {direction: 'row', justifyContent: 'center', alignItems: 'center'};
      case 'right': return {direction: 'row-reverse', justifyContent: 'flex-start', alignItems: 'flex-end'};
      default: return {direction: 'row', justifyContent: 'center', alignItems: 'center'};
    }    
  }

  borderRadius = 8;
  dropShadow1 = 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.6))';
  dropShadow = 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.2))';
  shiftMessageX = 10;
  shiftMessageY = 20;

  getBorderColor = (color) => {
    try{
      const borderColor = darken(color, this.shapeDarken);
      return borderColor
    } catch(error) {
      console.log('... DND getBorderColor darken ...', error);
      console.log('... DND getBorderColor darken ...', color, this.shapeDarken);
    }
    return color;
  }

  getViewBox = (viewBox) => `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`;

  pathCorner = (x, y, d) => {
    if (this.borderRadius === 0) return '';
    return ` a ${this.borderRadius} ${this.borderRadius} 0 0 ${d} ${x * this.borderRadius} ${y * this.borderRadius}`;
  }

  getMinWidth = () => {
    return this.shiftMessageX + this.borderRadius;
  }

  getMinHeight = () => {
    return this.shiftMessageY + this.borderRadius;
  }

  lastAlign = null;

  ViewMessage = (props) => {
    const report = this;
    const refBox = React.useRef(null);
    const backgroundColor = '#ffffff'
    const borderColor = this.getBorderColor(backgroundColor);
    const [path, setPath] = React.useState('m 0 0');    
    const [viewBox, setViewBox] = React.useState({x: 0, y: 0, width: 10, height: 10,});
    const filter = props.row.new === 1 ? this.dropShadow1 : this.dropShadow;
    const alignMsg = this.getAlingnMsg(props);

    const calculatePath = () => {
      if (!refBox.current) return;
      
      const rectBox = refBox.current.getBoundingClientRect();
      const width = rectBox.width - 2;
      const height = rectBox.height - 2;
      setViewBox({x: 0, y: 0, width: width, height: height});

      let path = null
      if (props.row.align === 'left') {
        if (props.row.added_by || props.row.newAlign) {
          path  = ` m ${-this.shiftMessageX} 0 `
                + ` h ${this.shiftMessageX + width - this.borderRadius} `
                + this.pathCorner(1, 1, 1)
                + ` v ${height - 2 * this.borderRadius} `
                + this.pathCorner(-1, 1, 1)   
                + ` h ${-(width - 2 * this.borderRadius)} `
                + this.pathCorner(-1, -1, 1)
                + ` v ${-(height - this.shiftMessageY - this.borderRadius)} `
                + ` q 0 ${-this.shiftMessageY} ${-this.shiftMessageX} ${-this.shiftMessageY} `
                ;
        } else {
          path  = ` m 0 0 `
                + ` h ${width - this.borderRadius} `
                + this.pathCorner(1, 1, 1)
                + ` v ${height - 2 * this.borderRadius} `
                + this.pathCorner(-1, 1, 1)
                + ` h ${-(width - 2 * this.borderRadius)} `
                + this.pathCorner(-1, -1, 1)
                + ` v ${-(height - this.borderRadius)} `
                ;
        }
      }

      if (props.row.align === 'right') {
        if (props.row.added_by || props.row.newAlign) {
          path  = ` m ${width + this.shiftMessageX} 0 `
                + ` h ${-(this.shiftMessageX + width - this.borderRadius)} `
                + this.pathCorner(-1, 1, 0) 
                + ` v ${height - 2 * this.borderRadius} `
                + this.pathCorner(1, 1, 0)                   
                + ` h ${width - 2 * this.borderRadius} `
                + this.pathCorner(1, -1, 0) 
                + ` v ${-(height - this.shiftMessageY - this.borderRadius)} `
                + ` q 0 ${-this.shiftMessageY} ${this.shiftMessageX} ${-this.shiftMessageY} `
                ;
        
        } else {
          path  = ` m ${width} 0 `
                + ` h ${-(width - this.borderRadius)} `
                + this.pathCorner(-1, 1, 0) 
                + ` v ${height - 2 * this.borderRadius} `
                + this.pathCorner(1, 1, 0)                   
                + ` h ${width - 2 * this.borderRadius} `
                + this.pathCorner(1, -1, 0) 
                + ` v ${-(height - this.borderRadius)} `
                ;
        }
      }

      setPath(path);
      this.lastAlign = props.row.align;
    }

    const handleOnClickTooltip = (event) => {      
      console.log('... ClickTooltip ...', event)
      Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId)
    }

    React.useEffect(() => {
      if (refBox.current) {
        new ResizeObserver((e) => calculatePath()).observe(refBox.current);
      }
    }, [refBox.current]);

    React.useEffect(() => calculatePath(), [this.borderRadius]);

    return (             
      <Box           
        ref={refBox}  
        px={1.5} 
        py={0.5} 
        position='relative'
        overflow='visible'
        minWidth={2 * this.borderRadius}
        minHeight={2 * this.borderRadius}
        maxWidth={'100%'}
        sx={{
          ...alignMsg,
          whiteSpace: 'pre-line', 
          wordWrap: 'break-word', 
          overflowWrap: 'anywhere',
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg"
          style={{position:'absolute', left:0, top: 0, width: '100%', height: '100%', overflow: 'visible'}} 
          viewBox={report.getViewBox(viewBox)}
          preserveAspectRatio='none'
          filter={filter}
        >
          <path d={path} stroke={borderColor} strokeWidth={report.borderWidth} fill={backgroundColor} />
        </svg>
        {props.row.centertop || props.row.centerbottom 
        ?
          <Typography variant='subtitle2' sx={{position: 'relative', color: 'rgba(0,0,0,.267)'}} dangerouslySetInnerHTML={{__html: props.row?.body}}/>
        :
          <Typography sx={{position: 'relative'}} dangerouslySetInnerHTML={{__html: props.row?.body}}/>        
        }
                        
      </Box>
    )
  }

  ViewRow = (props) => {
    const report = this;
    const smallScreen = React.useContext(SmallScreenContext);
    const [mouseOverField, setMouseOverField] = React.useState(false);
    const align = this.getAlingn(props);
    const [visibility, setVisibility] = React.useState(true);

    const handleMouseOverField = (e) => {    
      const willShowGear = e.type === 'mouseenter' ? true : false;
      //console.log('... mouseOverField ...', willShowGear)
      setMouseOverField(willShowGear);
    }

    const handleOnClickTooltip = (event) => {      
      console.log('... ClickTooltip ...', event)
      Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId)
    }

    React.useEffect(() => {
      if (!this.bs4KartotekaId) {
        return;
      }
  
      const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
      bs4Kartoteka.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);    
  
      return () => {
        const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
        if (bs4Kartoteka) bs4Kartoteka.off(setVisibility);
      }
    }, [setVisibility])      

    return (
      <Stack 
        direction={align.direction} justifyContent={align.justifyContent} alignItems="flex-start" spacing={1}        
        onMouseEnter={handleMouseOverField}
        onMouseLeave={handleMouseOverField}
      >
        {/* <Box minWidth={32} dangerouslySetInnerHTML={{__html: props.row.avatar}}/> */}
        <Bs4ViewAvatar 
          fileId={props.row.fileId} 
          initials={props.row.initials} 
          label={props.row.added_by} 
          circleColor={props.row.circleColor} 
          image_avatar={props.row.image_avatar}
        />
        <Stack direction="column" justifyContent="flex-start" alignItems={align.alignItems} spacing={0}>
          <Stack direction='row' 
            justifyContent="space-between"
            alignItems='center' spacing={1}>          
            {props.row.added_by ? <Typography variant='subtitle2' sx={{color: 'rgba(0,0,0,.5)', fontWeight: 500}}>{props.row.added_by}</Typography> : null}
            <Typography variant='subtitle2' sx={{color: 'rgba(0,0,0,.267)'}}>{props.row.added_when}</Typography>
          </Stack>
          <Stack direction={align.direction} justifyContent="flex-start" alignItems="flex-start" spacing={1}>   
            <report.ViewMessage row={props.row}/>            
            <Box 
              dangerouslySetInnerHTML={{__html: props.row.tooltip}} 
              onClick={handleOnClickTooltip} 
              visibility={visibility && (mouseOverField || smallScreen) ? 'visible' : 'hidden'}
              sx={{
                whiteSpace: 'nowrap', 
                wordWrap: 'normal', 
              }}              
            />
          </Stack>
          <div dangerouslySetInnerHTML={{__html: props.row.files}} />
        </Stack>        
      </Stack>
    )
  }

  getAligns = (data) => {
    const aligns = {};
    data.forEach(row => {      
      if (!(row.align in aligns)) aligns[row.align] = 0;
      aligns[row.align] = aligns[row.align] + 1;
    })
    return aligns;
  }

  getKeys = (data) => {
    const keys = {};
    data.forEach(row => {            
      for (const key of Object.keys(row)) {
        //if (key === 'avatar') console.log('... avatar ...', row, key)
        keys[key] = (keys[key] || 0)  + 1;
      }
    })
    return keys;
  }

  convertLastAlign = (data) => {
    let lastAlign = null;
    data.forEach(row => {
      if (row.align !== lastAlign) row.newAlign = true;        
      lastAlign = row.align;
    })    
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;  
    const [columnToShow, setColumnToShow] = React.useState(() => this.getColDef()?.[0]?.inputId || null)
    const [autoScroll, setAutoScroll] = React.useState(true)
    const [newItems, setNewItems] = React.useState(0)
    const [data, setData] = React.useState([]);
    const refScroll = React.useRef(null);
    const menuItems =  React.useMemo(() => Bs4Kartoteka.get(this.bs4KartotekaId).getReportMenu(this.optionId));
    this.startScrollingTitleNewText = Bs4I18N.useTT("Nowe +", 'New +', this.constructor.name);
    const setScrollTarget = useScrollTarget(this.optionId, props.formField);
    
    const handleFabClick = (event) => {
      setAutoScroll(true);
      setNewItems(0);
    }

    const addData = React.useCallback((dataAdded) => {
      const jsonData = this.convertData(dataAdded, columnToShow);
      // console.log('...addData.00.', jsonData);
      // console.log('...addData...', columnToShow, dataAdded, jsonData, autoScroll ? 0 : newItems + jsonData.length, autoScroll);
      // console.log('...addData.A.', this.getAligns(jsonData), this.getKeys(jsonData));
      const newData = [...data, ...jsonData];
      this.convertLastAlign(newData);
      setData(newData);
      setNewItems(autoScroll ? 0 : newItems + jsonData.length);
    }, [autoScroll, data]);

    const replaceData = React.useCallback((newData) => {
      const jsonData = this.convertData(newData, columnToShow);
      // console.log('...addData.01.', jsonData);
      // console.log('...replaceData...', columnToShow, newData, jsonData);
      // console.log('...replaceData.A.', this.getAligns(jsonData), this.getKeys(jsonData));
      this.convertLastAlign(jsonData);
      setData(jsonData);
      setNewItems(0);
    }, [autoScroll, data]);

    const scrollToBottom = React.useCallback((newData) => {
      if (!refScroll.current) return;
      refScroll.current.scrollTop = refScroll.current.scrollHeight;
    }, [refScroll.current]);      

    React.useEffect(() => {
      this.addData = addData;
      this.replaceData = replaceData;
      this.scrollToBottom = scrollToBottom;
    }, [addData, replaceData, refScroll.current]);

    React.useEffect(() => {
      // const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
      // if (bs4Kartoteka) bs4Kartoteka.setScrollTarget(refScroll.current, 'grid');
      setScrollTarget(refScroll.current);
      if (refScroll.current) refScroll.current.onscroll = (event)=> {
        if (refScroll.current.scrollHeight - refScroll.current.scrollTop - refScroll.current.clientHeight < 2) {
          setAutoScroll(true);
          setNewItems(0)
        } else {
          setAutoScroll(false);
        }        
      }
    }, [refScroll.current]);

    React.useEffect(() => {
      if (autoScroll) scrollToBottom();
    }, [autoScroll, data])

    React.useEffect(() => {            
      this.currentTitle = document.title;
      let intervalFetchMore = null;
      this.fetchMore(true);
      const reloadEvery = parseInt(this.props?.field?.reloadEvery);         
      if (reloadEvery > 0) {
        intervalFetchMore = setInterval(() => {
          try {
            //console.log('... infinity clearInterval ...>>>>>>>>>', intervalFetchMore, reloadEvery)
            this.fetchMore();            
          } catch(error) {
            console.log('... infinity clearInterval ...', intervalFetchMore, error)
            clearInterval(intervalFetchMore);      
          }            
        }, reloadEvery * 1000);
      }

      return () => {
        //console.log('... infinity unmount ...', intervalFetchMore, report);
        clearInterval(intervalFetchMore);
      }
    }, [])    

    //console.log('...infinity...', columnToShow, data, newItems, autoScroll);

    return (    
      <Box ref={ref} height='100%' width='100%' display='flex' flexDirection="column" overflow='hidden'>
        <Box flex={1} maxWidth='100%' overflow={'hidden'} position='relative' >
          <Box ref={refScroll} height={'100%'} maxWidth='100%' overflow='auto'>
            <Box display='flex' flexDirection='column' alignItems={'stretch'} gap={1} paddingBottom={1}>
              {data.map(row => <report.ViewRow key={row.id} row={row}/>)}
            </Box>                    
          </Box>
          <Bs4Tooltip arrow title={'Przewijaj wątek do najnowszej wiadomości (wł./wył.)'}>
            <Fab 
              variant="extended" 
              size="small" 
              color="primary" 
              onClick={handleFabClick}
              sx={{
                position:'absolute', 
                // 2024-04-13 'inherit' uwzględnia Bs4Kartoteka.setVisibility(visibility);
                visibility: !autoScroll ? 'inherit' : 'hidden', 
                bottom: 5, 
                right: '50%', 
                opacity: newItems > 0 ? 0.3 : 0.1
              }}
            >
              <i className="fa-solid fa-down-to-line"/>
              {newItems > 0 ? ' '+newItems : null}
            </Fab>
          </Bs4Tooltip>          
        </Box>
      </Box>
    )
  });
}